module.exports = __webpack_public_path__ + "static/media/Mr-T---Pastels-and-Charcoal.9cead081.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/thumbnails/Mr-T---Pastels-and-Charcoal.jpg
 ** module id = 445
 ** module chunks = 0
 **/